import { useCustomerMembershipContext } from "./CustomerMembershipContext";
import CustomerInfo, { CustomerInfoWrapper } from "./CustomerInfo";
import Product from "./Product";
import styled from "styled-components";
import ExternalTextLink from "../../shared/ExternalTextLink";

const ProductsWrapper = styled.div`
  ${CustomerInfoWrapper} {
    margin-bottom: 2em;
  }
`;

const TRIAL_MEMBERSHIP_WITH_ROAD_HELP_PRODUCT_ID = "6111";
const MEMBERSHIP_WITH_ROAD_HELP_PRODUCT_ID = "1111";
const MEMBERSHIP_WITHOUT_ROAD_HELP_PRODUCT_ID = "1121";

export default function Products() {
  const { yearlyProducts: products, customer } = useCustomerMembershipContext();

  const validProducts = customer.products.filter((p) => p.isValid);

  const trialMembership = validProducts.filter(
    (p) => p.id === TRIAL_MEMBERSHIP_WITH_ROAD_HELP_PRODUCT_ID
  )[0];

  const hasActiveTrialMembership =
    trialMembership && new Date(trialMembership.validUntil!) > new Date();

  const hasRegularMembership =
    customer.basic.hasMembership &&
    validProducts.filter((p) =>
      [
        MEMBERSHIP_WITH_ROAD_HELP_PRODUCT_ID,
        MEMBERSHIP_WITHOUT_ROAD_HELP_PRODUCT_ID,
      ].includes(p.id)
    ).length;

  if (hasRegularMembership) {
    return (
      <ProductsWrapper>
        <p>Dit NAF-medlemskap er aktivt.</p>
        <p>
          Gå til{" "}
          <ExternalTextLink href="https://naf.no/mitt-naf">
            Mitt NAF
          </ExternalTextLink>{" "}
          for å gjøre endringer.
        </p>

        <hr />
        <CustomerInfo />
      </ProductsWrapper>
    );
  }

  return (
    <ProductsWrapper>
      {products.length ? (
        <div>
          <h1>Betaling av ditt NAF-medlemskap</h1>
          {products
            .filter(({ id }) => id === MEMBERSHIP_WITH_ROAD_HELP_PRODUCT_ID)
            .map((product) => {
              return <Product product={product} key={product.id} />;
            })}
        </div>
      ) : (
        <div>
          <p>
            Vi fant ikke noe medlemskap som er klart til betaling på ditt
            medlemsnummer.
          </p>
          <p>
            Logg inn på{" "}
            <ExternalTextLink href="https://naf.no/medlemskap">
              naf.no
            </ExternalTextLink>{" "}
            for å melde deg inn eller endre medlemskapet.
          </p>
        </div>
      )}
      <hr />
      <CustomerInfo />
      {products.length ? (
        <>
          {trialMembership ? (
            hasActiveTrialMembership ? (
              <p>
                Prøvemedlemskapet ditt er gyldig til{" "}
                {new Date(trialMembership.validUntil!).toLocaleDateString()}.
                <br />
                Betal nå så beholder du NAF-medlemskapet etter endt
                prøveperiode.
              </p>
            ) : (
              <p>
                Prøvemedlemskapet ditt er utløpt.
                <br />
                Betal nå for å aktivere ditt NAF-medlemskap.
              </p>
            )
          ) : (
            <p>Medlemskapet er gyldig når betalingen er gjennomført.</p>
          )}
        </>
      ) : null}
    </ProductsWrapper>
  );
}
